// The shell only: the barrel also exports the Settings pages, which
// routes/pages.js loads lazily
import Internal from "components/layout/InternalLayout/Internal";
import { SidebarProvider } from "components/layout/sidebar";
import { useCancelableDebouncedApi } from "hooks";
import { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router";
import { selectDistrictData, patchCurrentUser } from "store/slices";
import { userApi } from "service/api";
import logger from "utils/logger";

const InternalLayout = () => {
  const location = useLocation();

  const dispatch = useDispatch();
  const { callApi } = useCancelableDebouncedApi();

  const { id: districtId } = useSelector(selectDistrictData);
  const { id = null, userId = null } = location.state || {};
  const handleNavigate = useCallback(
    async (id, userId) => {
      try {
        callApi(async () => {
          const res = await userApi.currentupdate(userId, { district_id: id });
          if (!res.error) {
            dispatch(
              patchCurrentUser({ primary_district_id: id }),
            );
          } else {
          }
          return res;
        });
      } catch (error) {
        logger.error("change district:-", error);
      }
    },
    [dispatch, callApi],
  );
  const hitApi = useMemo(
    () => (!!districtId ? !id || !userId || districtId === id : true),
    [id, userId, districtId],
  );

  useEffect(() => {
    if (!hitApi) {
      handleNavigate(id, userId);
    }
  }, [hitApi, handleNavigate, id, userId]);
  return (
    <SidebarProvider>
      <Internal>
        <Outlet />
      </Internal>
    </SidebarProvider>
  );
};

export default InternalLayout;
